/* oxlint-disable */
export enum ContentType {
  CAROUSEL = 'carousel',
  CAMPAIGN = 'campaign',
  PROMOTION = 'promotion',
  TOURNAMENT = 'tournament',
  JACKPOT = 'jackpot',
  RAFFLE = 'raffle',
  LEGAL = 'legal',
  ACADEMY = 'academy',
  UI_ELEMENT = 'ui-element',
  MARQUEE = 'marquee',
  SOCIAL_LINKS = 'social_links'
}

export enum CarouselContentSubType {
  HOME = 'home',
  CASINO = 'casino',
  SPORT = 'sport',
  SPORTBOOK = 'sportbook'
}

export enum CampaignContentSubType {
  CAMPAIGN = 'campaign',
  PROMOTION = 'promotion',
  TOURNAMENT = 'tournament',
  JACKPOT = 'jackpot',
  RAFFLE = 'raffle'
}

export enum LegalContentSubType {
  TERMS_AND_CONDITIONS = 'terms-and-conditions',
  PRIVACY = 'privacy',
  KYC_POLICIES = 'kyc-policies',
  MONEY_LAUNDERING = 'money-laundering',
  DISPUTES = 'disputes',
  FAQ = 'faq',
  BET_RULES = 'bet-rules',
  DEPOSITS = 'deposits',
  WITHDRAWALS = 'withdrawals',
  BETTING_LIMIT = 'betting-limit',
  RESPONSIBILITY = 'responsibility',
  BONUS_CONDITIONS = 'bonus-conditions',
  MARKETPLACE = 'marketplace',
}

export enum UIElementContentSubType {
  FLOATING_BUTTON_HOME = 'floating-button-home'
}

export interface ContentSubType {
  [ContentType.CAROUSEL]: CarouselContentSubType;
  [ContentType.CAMPAIGN]: CampaignContentSubType;
  [ContentType.LEGAL]: LegalContentSubType;
  [ContentType.UI_ELEMENT]: UIElementContentSubType;
}

export enum ContentStatus {
  DRAFT = 'draft',
  LIVE = 'live',
  INACTIVE = 'inactive',
}
export interface Content {
  id: number;
  title: string;
  content_type: ContentType;
  content_subtype?: string | null;
  content_html?: string | null;
  image_url?: string | null;
  image_alt?: string | null;
  metadata?: any;
  start_date?: Date | null;
  end_date?: Date | null;
  cta_text?: string | null;
  short_description?: string | null;
  display_order?: number | null;
  slug?: string | null;
}

export interface ContentQueryResponse {
  status: boolean;
  data: Content[] | Content | null;
  total?: number;
  success?: boolean;
}

export interface ContentResponse {
  success: boolean;
  data: Content[];
  error?: string;
}

export interface FooterLink {
  title: string;
  href: string;
  external?: boolean;
}

export interface FooterLinkSection {
  title: string;
  links: FooterLink[];
}

export interface FooterLinksProps {
  sections: FooterLinkSection[];
}

export interface PromotionData {
  id: string;
  title: string;
  startDate: Date | null;
  endDate: Date | null;
  imageUrl: string | null;
  alt: string | null;
  urlRedirection: string | null;
  body: any;
  orderRank: string;
  app: string;
  slug: string | null;
  imageUrlLanding: string | null;
  prizePool: number;
}

export interface HtmlParserOptions {
  h1Classes?: string;
  h2Classes?: string;
  h3Classes?: string;
  h4Classes?: string;
  h5Classes?: string;
  h6Classes?: string;
  pClasses?: string;
  ulClasses?: string;
  liClasses?: string;
  aClasses?: string;
  strongClasses?: string;
  imgClasses?: string;
}

export interface HtmlRendererProps {
  htmlString: string;
  customClasses?: HtmlParserOptions;
}

export interface CacheEntry<T> {
  data: T;
  timestamp: number;
  expiresAt: number;
}

export interface FooterDescriptionData {
  text: string;
  longText: string;
  more: string;
  less: string;
}

export interface FooterDescriptionProps {
  description: FooterDescriptionData | null;
}

export interface SocialLink {
  title: string;
  image_url: string;
  url: string;
  platform: string;
  order: number;
}